/**
 * Get array of objects back minus the one with the id that you passed in.
 * @param {Object} args - Object to be deconstructed which contains arguments.
 * @param {String} args.id - Id of object you want omit from the state.
 * @param {Array<Object>} args.state - Array of objects that have an `id` property.
 * @return {Array[Object]} The state passed in, minus the object with the id property that was passed in as the `id` parameter.
 */

export default function findAllButById({ id, state }) {
  return state.filter(x => x.id !== id)
}



// WEBPACK FOOTER //
// ./src/helpers/findAllButById.js